// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeUsernameClaimBody = {
  username: string;
};

export type typeUsernameClaimOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    profile: {
      accountId: string;
      username: string;
      displayName: string;
      firstName?: string | null;
      lastName?: string | null;
      birthday?: string | null;
      phone?: string | null;
      photoUrl?: string | null;
      timezone: string;
      isDiscoverable: boolean;
      isPoolListVisible: boolean;
      followedSportIds: string[];
      followedLeagueIds: string[];
      favoriteTeamIds: string[];
      onboardingStep:
        | "username"
        | "details"
        | "signInMethods"
        | "photo"
        | "sports"
        | "leagues"
        | "done";
      isOnboardingComplete: boolean;
      usernameChangedAt?: string | null;
      usernameChangeCount: number;
      createdAt: string;
      usernameChangeAvailableAt?: string | null;
    };
  };
};

export type typeUsernameClaimOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeUsernameClaimOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeUsernameClaimOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaUsernameClaimBody = {
  type: "object",
  properties: { username: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["username"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createUsernameClaim(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaUsernameClaimBody);
  }

  return async function postUsernameClaim(
    payload: typeUsernameClaimBody,
  ): Promise<typeUsernameClaimOutput200 | typeUsernameClaimOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postUsernameClaim" failed before calling the network. #5c5fe04fa0a6`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#5c5fe04fa0a6" },
        },
        data: null,
      } as typeUsernameClaimOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/username/claim`,
      httpMethod: "POST",
      options,
    })) as typeUsernameClaimOutput200 | typeUsernameClaimOutput400;
  };
}
